// Mengelompokkan import statements
import Vue from 'vue';
import VueRouter from 'vue-router';
import { logout } from '../services/authService';
import authMiddleware, { checkRoleRedirect } from '@/middleware/auth';
import store from '../store';

// Sisipkan import statements yang dipindahkan di atas

// login
import LoginView from '../views/LoginView.vue';
import RegisterView from '../views/RegisterVue.vue';
import ForgotPassword from '../views/ForgotPassword.vue';
import HomeView from '../views/HomeView.vue';

// dashboard
import DashboardView from '../views/DashboardView.vue';

// owner
import ListOwner from '../views/Owner/ListView.vue';
import DetailOwner from '../views/Owner/DetailView.vue';
import CreateOwner from '../views/Owner/CreateView.vue';
import EditOwner from '../views/Owner/EditView.vue';
import ExecutiveAnalyticsView from '../views/Owner/ExecutiveAnalyticsView.vue';

// maker
import ListMaker from '../views/Maker/ListView.vue';
import DetailMaker from '../views/Maker/DetailView.vue';
import CreateMaker from '../views/Maker/CreateView.vue';
import EditMaker from '../views/Maker/EditView.vue';
import MakerStudioView from '../views/Maker/MakerStudioView.vue';

// player
import ListPlayer from '../views/Player/ListView.vue';
import DetailPlayer from '../views/Player/DetailView.vue';
import CreatePlayer from '../views/Player/CreateView.vue';
import EditPlayer from '../views/Player/EditView.vue';

// payment
import ListPayment from '../views/PaymentManagement/ListView.vue';
import DetailPayment from '../views/PaymentManagement/DetailView.vue';
import CreatePayment from '../views/PaymentManagement/CreateView.vue';
import EditPayment from '../views/PaymentManagement/EditView.vue';

// billing & transaction
import BillingView from '../views/BillingView.vue';
import BillingPayView from '../views/PayBilling.vue';
import QuotaAddView from '../views/QuotaAdd.vue';
import QuotaView from '../views/QuotaView.vue';
import DetailQuota from '../views/PayDetail.vue';

// squad
import SquadView from '../views/Squad/SquadView.vue';
import DetailSquad from '../views/Squad/DetailSquad.vue';
import CreateSquad from '../views/Squad/CreateSquad.vue';
import EditSquad from '../views/Squad/EditSquad.vue';

// Ruang Kerja Virtual 3D & Marketplace
import RealmMarketplaceView from '../views/RealmMarketplaceView.vue';

// game settings & guide
import GameSettingsView from '../views/GameSettingsView.vue';

// redeem
import ListRedeem from '../views/Redeem/RedeemView.vue';
import DetailRedeem from '../views/Redeem/DetailRedeem.vue';
import CreateRedeem from '../views/Redeem/CreateRedeem.vue';
import EditRedeem from '../views/Redeem/EditRedeem.vue';

// approval
import RewardsApproval from '../views/Approval/RewardApproval.vue';
import EditRewardApproval from '../views/Approval/EditRewardApproval.vue';
import ConsequenceApproval from '../views/Approval/ConsequenceApproval.vue';
import EditConsequenceApproval from '../views/Approval/EditConsequenceApproval.vue';
import CompensationApproval from '../views/Approval/CompensationApproval.vue';
import EditCompensationApproval from '../views/Approval/EditCompensationApproval.vue';
import PunishmentApproval from '../views/Approval/PunishmentApproval.vue';
import EditPunishmentApproval from '../views/Approval/EditPunishmentApproval.vue';

// rules
import ListRewards from '../views/Rules/RewardList.vue';
import CreateReward from '../views/Rules/CreateReward.vue';
import DetailReward from '../views/Rules/DetailReward.vue';
import EditReward from '../views/Rules/EditReward.vue';
import ConsequenceList from '../views/Rules/ConsequenceList.vue';
import CreateConsequence from '../views/Rules/CreateConsequence.vue';
import DetailConsequence from '../views/Rules/DetailConsequence.vue';
import EditConsequence from '../views/Rules/EditConsequence.vue';
import CompensationList from '../views/Rules/CompensationList.vue';
import CreateCompensation from '../views/Rules/CreateCompensation.vue';
import DetailCompensation from '../views/Rules/DetailCompensation.vue';
import EditCompensation from '../views/Rules/EditCompensation.vue';

// package
import ListPackage from '../views/Package/ListPackage.vue';
import DetailPackage from '../views/Package/DetailPackage.vue';
import CreatePackage from '../views/Package/CreatePackage.vue';
import EditPackage from '../views/Package/EditPackage.vue';

// profile
import ProfileView from '../views/ProfileView.vue'; // Added import for ProfileView
import ProfileEditView from '../views/ProfileEditView.vue'; // Added import for ProfileView
import ProfileEditPassword from '../views/ProfileEditPassword.vue'; // Added import for ProfileView

//discount
import DiscountList from '@/views/Discount/ListView.vue';
import CreateDiscount from '@/views/Discount/CreateView.vue';
import EditDiscont from '@/views/Discount/EditView.vue';
import DetailDiscount from '@/views/Discount/DetailView.vue';
import CekVue from '@/views/CekVue.vue';
import PayView from '@/views/PayView.vue';
import PayDetail from '@/views/PayDetail.vue';
import AddquotaVue from '@/views/AddquotaVue.vue';

import AdminMaker from '@/views/AdminMaker/ListView.vue';
import AdminPlayer from '@/views/AdminPlayer/ListView.vue';
import GlossaryView from '@/views/GlossaryView.vue';


Vue.use(VueRouter);

// Mengelompokkan definisi routes
const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem('authToken');
      if (token) {
        next('/dashboard');
      } else {
        next('/login');
      }
    }
  },
  { path: '/login', name: 'Login', component: LoginView },
  { path: '/register', name: 'Register', component: RegisterView },
  { path: '/forgotpassword', name: 'ForgotPassword', component: ForgotPassword },
  { path: '/forgot-password', name: 'ForgotPasswordAlias', component: ForgotPassword },
  { path: '/reset-password', name: 'ResetPassword', component: ForgotPassword },
  { path: '/dashboard', name: 'Dashboard', component: DashboardView, beforeEnter: authMiddleware },
  { path: '/glossary', name: 'Glossary', component: GlossaryView, beforeEnter: authMiddleware },
  { path: '/tutorial', redirect: '/glossary' },
  { path: '/panduan', redirect: '/glossary' },
  { path: '/audit-logs', name: 'AuditLogs', component: () => import('@/views/Superadmin/AuditLogView.vue'), beforeEnter: authMiddleware },
  { path: '/audit-log', redirect: '/audit-logs' },
  { path: '/inbound-leads', name: 'InboundLeads', component: () => import('@/views/Superadmin/InboundLeadsView.vue'), beforeEnter: authMiddleware },
  { path: '/leads', redirect: '/inbound-leads' },
  { path: '/game-benchmarks', name: 'GameSettingBenchmarks', component: () => import('@/views/Superadmin/GameSettingBenchmarkView.vue'), beforeEnter: authMiddleware },
  { path: '/creators', name: 'CreatorEcosystem', component: () => import('@/views/Superadmin/CreatorEcosystemView.vue'), beforeEnter: authMiddleware },
  { path: '/superadmin', redirect: '/dashboard' },
  { path: '/superadmin/companies', redirect: '/owner' },
  { path: '/superadmin/realms', redirect: '/realms/marketplace' },
  { path: '/superadmin/settings', redirect: '/game-benchmarks' },
  { path: '/creator-ecosystem', redirect: '/creators' },
  { path: '/superadmin/creator-ecosystem', redirect: '/creators' },
  { path: '/superadmin/creators', redirect: '/creators' },
  { path: '/superadmin/audit-logs', redirect: '/audit-logs' },
  { path: '/superadmin/leads', redirect: '/inbound-leads' },
  { path: '/superadmin/benchmarks', redirect: '/game-benchmarks' },
  { path: '/superadmin/quota', redirect: '/quota' },
  { path: '/game-settings', name: 'GameSettings', component: GameSettingsView, beforeEnter: authMiddleware },
  { path: '/realms/marketplace', name: 'RealmMarketplace', component: RealmMarketplaceView, beforeEnter: authMiddleware },
  { path: '/realm-marketplace', redirect: '/realms/marketplace' },
  { path: '/realms', redirect: '/realms/marketplace' },
  { path: '/marketplace', redirect: '/realms/marketplace' },
  { path: '/analytics', redirect: '/owner/analytics' },
  { path: '/executive-analytics', redirect: '/owner/analytics' },
  { path: '/maker-studio', redirect: '/maker/studio' },
  { path: '/studio', redirect: '/maker/studio' },
  { path: '/rewards', redirect: '/rules/rewards' },
  { path: '/quests', redirect: '/rules/rewards' },
  { path: '/consequence', redirect: '/rules/consequence' },
  { path: '/consequences', redirect: '/rules/consequence' },
  { path: '/compensation', redirect: '/rules/compensation' },
  { path: '/compensations', redirect: '/rules/compensation' },
  { path: '/rewardsapproval', redirect: '/approval/rewards' },
  { path: '/punishmentapproval', redirect: '/approval/punishment' },
  { path: '/approval/punishments', redirect: '/approval/punishment' },
  { path: '/approval/consequences', redirect: '/approval/consequence' },
  { path: '/approval/compensations', redirect: '/approval/compensation' },
  { path: '/approvals', redirect: '/approval/rewards' },
  { path: '/approvals/rewards', redirect: '/approval/rewards' },
  { path: '/approvals/reward', redirect: '/approval/rewards' },
  { path: '/approvals/consequence', redirect: '/approval/consequence' },
  { path: '/approvals/consequences', redirect: '/approval/consequence' },
  { path: '/approvals/compensation', redirect: '/approval/compensation' },
  { path: '/approvals/compensations', redirect: '/approval/compensation' },
  { path: '/approvals/punishment', redirect: '/approval/punishment' },
  { path: '/approvals/punishments', redirect: '/approval/punishment' },
  { path: '/players', redirect: '/player' },
  { path: '/makers', redirect: '/maker' },
  { path: '/owners', redirect: '/owner' },
  { path: '/squads', redirect: '/squad' },
  { path: '/redeems', redirect: '/redeem' },
  { path: '/packages', redirect: '/package' },
  { path: '/discounts', redirect: '/discount' },
  { path: '/payments', redirect: '/payment' },
  { path: '/admin-maker', redirect: '/adminmaker' },
  { path: '/admin-player', redirect: '/adminplayer' },
  { path: '/cek', name: 'Cek', component: CekVue, beforeEnter: authMiddleware },
  { path: '/pay', name: 'Pay', component: PayView, beforeEnter: authMiddleware },
  { path: '/addquota', name: 'AddQuota', component: AddquotaVue, beforeEnter: authMiddleware },
  { path: '/paydetail', name: 'PayDetail', component: PayDetail, beforeEnter: authMiddleware, props: true },
  {
    path: '/billing',
    component: { render (c) { return c('router-view') } },
    beforeEnter: authMiddleware,
    children: [
      { path: '', name: 'Billing', component: BillingView },
      { path: 'pay', name: 'BillingPay', component: BillingPayView },
      { path: 'detail', name: 'DetailBilling', component: DetailQuota, props: true }
    ]
  },
  {
    path: '/discount',
    component: { render (c) { return c('router-view') } },
    beforeEnter: authMiddleware,
    children: [
      { path: '', name: 'discount', component: DiscountList },
      { path: 'detail/:id', name: 'DetailDiscount', component: DetailDiscount, props: true },
      { path: 'add', name: 'CreateDiscount', component: CreateDiscount },
      { path: 'create', redirect: 'add' },
      { path: 'edit/:id', name: 'Editdiscont', component: EditDiscont, props: true },
    ]
  },
  {
    path: '/quota',
    component: { render (c) { return c('router-view') } },
    beforeEnter: authMiddleware,
    children: [
      { path: '', name: 'Quota', component: QuotaView },
      { path: 'add', name: 'QuotaAdd', component: QuotaAddView },
      { path: 'create', redirect: 'add' },
      { path: 'detail/:id', name: 'DetailQuota', component: DetailQuota, props: true }
    ]
  },
  {
    path: '/squad',
    component: { render (c) { return c('router-view') } },
    beforeEnter: authMiddleware,
    children: [
      { path: '', name: 'ListSquad', component: SquadView },
      { path: 'detail/:id', name: 'DetailSquad', component: DetailSquad, props: true },
      { path: 'add', name: 'CreateSquad', component: CreateSquad },
      { path: 'create', redirect: 'add' },
      { path: 'edit/:id', name: 'EditSquad', component: EditSquad, props: true },
    ]
  },
 

  
  {
    path: '/adminmaker',
    component: { render (c) { return c('router-view') } },
    beforeEnter: authMiddleware,
    children: [
      { path: '', name: 'ListMakerAdmin', component: AdminMaker },
    
    ]
  },
 
  {
    path: '/adminplayer',
    component: { render (c) { return c('router-view') } },
    beforeEnter: authMiddleware,
    children: [
      { path: '', name: 'ListPlayerAdmin', component: AdminPlayer, },
    
    ],
    
  },

  {
    path: '/redeem',
    component: { render (c) { return c('router-view') } },
    beforeEnter: authMiddleware,
    children: [
      { path: '', name: 'ListRedeem', component: ListRedeem },
      { path: 'detail/:id', name: 'DetailRedeem', component: DetailRedeem, props: true },
      { path: 'add', name: 'CreateRedeem', component: CreateRedeem },
      { path: 'create', redirect: 'add' },
      { path: 'edit/:id', name: 'EditRedeem', component: EditRedeem, props: true },
    ]
  },
  {
    path: '/rules',
    name: 'Rules',
    component: { render (c) { return c('router-view') } },
    beforeEnter: authMiddleware,
    redirect: '/rules/rewards',
    children: [
      { path: '', redirect: 'rewards' },
      { path: 'rewards', name: 'ListRewards', component: ListRewards },
      { path: 'reward', redirect: 'rewards' },
      { path: 'create-reward', redirect: 'reward/create' },
      { path: 'rewards/add', redirect: 'reward/create' },
      { path: 'rewards/create', redirect: 'reward/create' },
      { path: 'reward/add', redirect: 'reward/create' },
      { path: 'add', redirect: 'reward/create' },
      { path: 'reward/create', name: 'CreateReward', component: CreateReward },
      { path: 'reward/detail/:id', name: 'DetailReward', component: DetailReward, props: true },
      { path: 'reward/edit/:id', name: 'EditReward', component: EditReward, props: true },
      { path: 'consequences', name: 'ListConsequence', component: ConsequenceList },
      { path: 'consequence', redirect: 'consequences' },
      { path: 'consequences/create', redirect: 'consequence/create' },
      { path: 'consequences/add', redirect: 'consequence/create' },
      { path: 'consequence/add', redirect: 'consequence/create' },
      { path: 'consequence/create', name: 'CreateConsequence', component: CreateConsequence },
      { path: 'consequence/detail/:id', name: 'DetailConsequence', component: DetailConsequence, props: true },
      { path: 'consequence/edit/:id', name: 'EditConsequence', component: EditConsequence, props: true },
      { path: 'compensations', name: 'Compensation', component: CompensationList },
      { path: 'compensation', redirect: 'compensations' },
      { path: 'compensations/create', redirect: 'compensation/create' },
      { path: 'compensations/add', redirect: 'compensation/create' },
      { path: 'compensation/add', redirect: 'compensation/create' },
      { path: 'compensation/create', name: 'CreateCompensation', component: CreateCompensation },
      { path: 'compensation/detail/:id', name: 'DetailCompensation', component: DetailCompensation, props: true },
      { path: 'compensation/edit/:id', name: 'EditCompensation', component: EditCompensation, props: true },
    ]
  },
  {
    path: '/approval',
    name: 'Approval',
    component: { render (c) { return c('router-view') } },
    beforeEnter: authMiddleware,
    redirect: '/approval/rewards',
    children: [
      { path: '', redirect: 'rewards' },
      { path: 'reward', redirect: 'rewards' },
      { path: 'rewards', name: 'RewardsApproval', component: RewardsApproval },
      { path: 'reward/edit/:id', name: 'EditRewardApproval', component: EditRewardApproval, props: true },
      { path: 'consequence', name: 'ConsequenceApproval', component: ConsequenceApproval },
      { path: 'consequence/edit/:id', name: 'EditConsequenceApproval', component: EditConsequenceApproval, props: true },
      { path: 'compensation', name: 'CompensationApproval', component: CompensationApproval },
      { path: 'compensation/edit/:id', name: 'EditCompensationApproval', component: EditCompensationApproval, props: true },
      { path: 'punishment', name: 'PunishmentApproval', component: PunishmentApproval },
      { path: 'punishment/edit/:id', name: 'EditPunishmentApproval', component: EditPunishmentApproval, props: true },
    ]
  },
  {
    path: '/voucher',
    redirect: '/discount'
  },
  {
    path: '/leaderboard',
    redirect: '/player'
  },
  {
    path: '/owner',
    component: { render (c) { return c('router-view') } },
    beforeEnter: authMiddleware,
    children: [
      { path: '', name: 'ListOwner', component: ListOwner },
      { path: 'analytics', name: 'ExecutiveAnalytics', component: ExecutiveAnalyticsView },
      { path: 'detail/:id', name: 'DetailOwner', component: DetailOwner, props: true },
      { path: 'add', name: 'CreateOwner', component: CreateOwner },
      { path: 'create', redirect: 'add' },
      { path: 'edit/:id', name: 'EditOwner', component: EditOwner, props: true }
    ]
  },
  {
    path: '/maker',
    component: { render (c) { return c('router-view') } },
    beforeEnter: authMiddleware,
    children: [
      { path: '', name: 'ListMaker', component: ListMaker },
      { path: 'studio', name: 'MakerStudio', component: MakerStudioView },
      { path: 'detail/:id', name: 'DetailMaker', component: DetailMaker, props:true },
      { path: 'add', name: 'CreateMaker', component: CreateMaker },
      { path: 'create', redirect: 'add' },
      { path: 'edit/:id', name: 'EditMaker', component: EditMaker, props:true }
    ]
  },
  {
    path: '/package',
    component: { render (c) { return c('router-view') } },
    beforeEnter: authMiddleware,
    children: [
      { path: '', name: 'ListPackage', component: ListPackage },
      { path: 'detail/:id', name: 'DetailPackage', component: DetailPackage, props:true },
      { path: 'add', name: 'CreatePackage', component: CreatePackage },
      { path: 'create', redirect: 'add' },
      { path: 'edit/:id', name: 'EditPackage', component: EditPackage, props:true }
    ]
  },
  {
    path: '/player',
    component: { render (c) { return c('router-view') } },
    beforeEnter: authMiddleware,
    children: [
      { path: '', name: 'ListPlayer', component: ListPlayer },
      { path: 'detail/:id', name: 'DetailPlayer', component: DetailPlayer, props: true },
      { path: 'add', name: 'CreatePlayer', component: CreatePlayer },
      { path: 'create', redirect: 'add' },
      { path: 'edit/:id', name: 'EditPlayer', component: EditPlayer, props: true }
    ]
  },
  {
    path: '/profile',
    component: { render (c) { return c('router-view') } },
    beforeEnter: authMiddleware,
    children: [
      { path: '', name: 'Profile', component: ProfileView },
      { path: 'edit', name: 'ProfileEdit', component: ProfileEditView },
      { path: 'password', redirect: 'edit/password' },
      { path: 'edit/password', name: 'ProfileEditPassword', component: ProfileEditPassword }
    ]
  },
  {
    path: '/payment',
    component: { render (c) { return c('router-view') } },
    beforeEnter: authMiddleware,
    children: [
      { path: '', name: 'ListPayment', component: ListPayment },
      { path: 'detail/:id', name: 'DetailPayment', component: DetailPayment, props: true },
      { path: 'add', name: 'CreatePayment', component: CreatePayment },
      { path: 'create', redirect: 'add' },
      { path: 'edit/:id', name: 'EditPayment', component: EditPayment, props: true }
    ]
  },
  {
    path: '/logout',
    name: 'Logout',
    beforeEnter: async (to, from, next) => {
      try {
        await logout();
      } catch (e) {
        console.error('Logout error:', e);
      }
      next('/login');
    }
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
];

// Mengelompokkan pembuatan router
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const user = store.state.user;
  if (user) {
    const redirectTarget = checkRoleRedirect(to.path, user);
    if (redirectTarget && to.path !== redirectTarget) {
      next(redirectTarget);
      return;
    }
  }
  next();
});

export default router;